import { useEffect, useState, useRef } from "react";

import styles from "./Face2.module.scss";

export default function Face2() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined
  );
  const [marginTop, setMarginTop] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.034 * cardRef.current.clientWidth));
        setLineHeight(0.08 * cardRef.current.clientWidth);
        setLetterSpacing(0.004 * cardRef.current.clientWidth);
        setMarginTop(0.0 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          lineHeight: `${lineHeight}px`,
          marginTop: `${marginTop}px`,
          letterSpacing: `${letterSpacing}px`,
          textAlign: "center",
        }}
      >
        <p>Ja i moji prijatelji, vječno mimoilaženi.</p>
        <p>Ispražnjenih tijela, vučemo se po primaćoj.</p>
        <p>Zaboravim, stvarno me iznenadi prizor,</p>
        <p>kad u posjeti vidim njihov maxi televizor.</p>
        <p>Svake godine iznenađeno progutam riječi,</p>
        <p>Kako je moguće da je svaki put sve veći?</p>
      </div>
    </div>
  );
}
